module.exports = __webpack_public_path__ + "static/img/74.241ad95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/74.png
// module id = baP7
// module chunks = 0